var styles = {"inputHint":"styles_input-hint__yyDLi","dark":"styles_dark__sr286"};

export { styles as default };
//# sourceMappingURL=styles.css.js.map
